export default class connections {
    static sdkurl = "https://sdk.aeyehealth.com"
    static forgotpasswordurl = "https://clinics.aeyehealth.com"

}